class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.viewport = this.querySelector('.pc-viewport');
    this.track = this.querySelector('.pc-track');
    this.slides = Array.from(this.querySelectorAll('.pc-slide'));
    this.prevBtn = this.querySelector('.pc-arrow--prev');
    this.nextBtn = this.querySelector('.pc-arrow--next');
    this.dotsWrap = this.querySelector('.pc-dots');
    this.index = 0;
    this.autoplayTimer = null;

    this.onResize = this.onResize.bind(this);
    this.goPrev = this.goPrev.bind(this);
    this.goNext = this.goNext.bind(this);
  }

  connectedCallback() {
    if (!this.track || this.slides.length === 0) return;

    this.buildDots();
    this.update();

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.goPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.goNext);

    window.addEventListener('resize', this.onResize);

    this.setupSwipe();

    if (this.dataset.autoplay === 'true') {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.stopAutoplay();
  }

  getVisibleCount() {
    const viewportWidth = this.viewport.getBoundingClientRect().width;
    const slideWidth = this.slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const count = Math.floor((viewportWidth + gap) / (slideWidth + gap));
    return Math.max(1, count);
  }

  getMaxIndex() {
    const visible = this.getVisibleCount();
    return Math.max(0, this.slides.length - visible);
  }

  onResize() {
    const maxIndex = this.getMaxIndex();
    if (this.index > maxIndex) this.index = maxIndex;
    this.buildDots();
    this.update();
  }

  goPrev() {
    this.index = Math.max(0, this.index - 1);
    this.update();
    this.restartAutoplay();
  }

  goNext() {
    const maxIndex = this.getMaxIndex();
    this.index = Math.min(maxIndex, this.index + 1);
    this.update();
    this.restartAutoplay();
  }

  goTo(i) {
    const maxIndex = this.getMaxIndex();
    this.index = Math.min(Math.max(0, i), maxIndex);
    this.update();
    this.restartAutoplay();
  }

  update1() //without scroll
  { 
    const slideWidth = this.slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const maxIndex = this.getMaxIndex();

    if (maxIndex === 0) {
      this.classList.add('is-centered');
      this.track.style.transform = 'translateX(0)';
    } else {
      this.classList.remove('is-centered');
      const offset = this.index * (slideWidth + gap);
      this.track.style.transform = `translateX(-${offset}px)`;
    }

    if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index >= maxIndex;

    if (this.dotsWrap) {
      const dots = Array.from(this.dotsWrap.children);
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
    }
  }
  update() //with scroll
  {
    const slideWidth = this.slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const offset = this.index * (slideWidth + gap);
    this.track.style.transform = `translateX(-${offset}px)`;

    const maxIndex = this.getMaxIndex();
    if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index >= maxIndex;

    if (this.dotsWrap) {
      const dots = Array.from(this.dotsWrap.children);
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
    }
  }

  buildDots() {
    if (!this.dotsWrap) return;
    const maxIndex = this.getMaxIndex();
    this.dotsWrap.innerHTML = '';
    for (let i = 0; i <= maxIndex; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pc-dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to position ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
    }
  }

  setupSwipe() {
    let startX = 0;
    let isDown = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDown = true;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!isDown) return;
      isDown = false;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? this.goNext() : this.goPrev();
      }
    });
  }

  startAutoplay() {
    const speed = parseInt(this.dataset.autoplaySpeed) || 5000;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      const maxIndex = this.getMaxIndex();
      this.index = this.index >= maxIndex ? 0 : this.index + 1;
      this.update();
    }, speed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (this.dataset.autoplay === 'true') this.startAutoplay();
  }
}

customElements.define('product-carousel', ProductCarousel);
